import React, { createContext, useContext } from 'react';
import { MultiStepForm, useMultiStepForm } from '../useMultistepForm';

interface MultiStepFormContext {
	formStepsLength: number;
	children: React.ReactNode;
}

const context = createContext<MultiStepForm>({} as MultiStepForm);

export const MultiStepFormProvider = ({ formStepsLength, children }: MultiStepFormContext) => {
	const multiStepForm = useMultiStepForm(formStepsLength);
	return <context.Provider value={multiStepForm}>{children}</context.Provider>;
};

export const useMultiStepFormContext = () => useContext(context);
